<template>
    <div class="web">
        <Header :type="'faq'"></Header>
        <main class="py-5 faq">
        <div class="container mb-5">
            <div class="row mb-4">
                <h1 class="text-grey text-center">¿Qué nos preguntan <span class="text-light-grey bg-orange px-3">los
                        Consultores</span>?</h1>
            </div>

            <div class="row">
                <p><strong>¿Cuál es el costo de registro en la plataforma?</strong></p>

                <p>Nos complace informarte que el registro en nuestra plataforma es totalmente gratuito. Queremos
                    brindarte
                    la
                    oportunidad de unirte a nuestra comunidad sin ningún costo. No hay barreras económicas para comenzar
                    a
                    explorar las diversas oportunidades y servicios que ofrecemos.</p>

                <p> Así que, ¡no dudes en registrarte hoy mismo y descubrir todo lo que nuestra plataforma tiene para
                    ofrecerte
                    sin ningún costo inicial!</p>

                <p><strong>¿Tendré acceso a todos los proyectos publicados?</strong></p>

                <p>Al registrarte en nuestra plataforma, tendrás acceso y la posibilidad de revisar todos los proyectos
                    que
                    se
                    publiquen y que coincidan con las especialidades que hayas registrado en tu perfil.</p>

                <p>¡Pero eso no es todo! Como parte de nuestros servicios, nos aseguraremos de mantenerte informado de
                    manera
                    proactiva cuando surja alguna oportunidad en la que puedas participar. De esta forma, te
                    garantizamos
                    que no
                    te perderás ninguna oportunidad relevante para ti.</p>

                <p><strong>¿Cómo puedo presentar una propuesta para un proyecto de mi interés?</strong></p>

                <p>Dependiendo del tipo de membresía que hayas adquirido te brindamos la oportunidad de presentar
                    propuestas
                    para proyectos que sean de tu interés.</p>

                <p>Lo mejor de todo es que podrás aprovechar diversas funcionalidades y ventajas adicionales para
                    destacar
                    en
                    tus propuestas y aumentar tus posibilidades de éxito.</p>

                <p><strong>¿Es posible cancelar mi membresía?</strong></p>

                <p>Cuando adquieres una membresía, se establece un pago recurrente según el plan que hayas seleccionado.
                    Sin
                    embargo, tienes la opción de modificarlo según tu conveniencia o cancelar la renovación automática
                    en
                    cualquier momento.</p>

                <p><strong>¿Cómo puedo actualizar y mejorar mi perfil y especialidades en la plataforma?</strong></p>
                <p>Nos preocupamos por ofrecerte un perfil completo y actualizado que destaque tus habilidades y
                    experiencia.
                    Si necesitas realizar alguna actualización o corrección en tu perfil, no dudes en contactarnos.
                    Nuestro
                    equipo estará encantado de ayudarte y brindarte asistencia personalizada para asegurarnos de que tu
                    perfil
                    refleje lo mejor de ti y tus capacidades.</p>

                <p>¡Queremos asegurarnos de que aproveches al máximo todas las oportunidades que nuestra plataforma
                    puede
                    ofrecerte!</p>



                <p><strong>¿Cuál es la importancia del orden de las especializaciones al momento en que un cliente
                        publica
                        un proyecto?</strong></p>
                <p>El orden de las especializaciones requeridas por el cliente para su proyecto es de gran relevancia,
                    ya
                    que
                    esto también determina si puedes enviar una propuesta o no a ese proyecto, dependiendo del tipo de
                    membresía
                    que hayas adquirido y del orden específico solicitado por el cliente.</p>

                <p>El orden de las especializaciones impacta directamente en las oportunidades a las que puedes
                    postularte.
                    A
                    continuación, se presenta una tabla ejemplificando cómo el orden de las especializaciones afecta las
                    oportunidades disponibles según el tipo de membresía:</p>

                <table class="table table-orange table-striped">
                    <thead>
                        <th>Tipo de Membresía</th>
                        <th>Especialización a ser considerada</th>
                        <th>Especialización requerida por el cliente</th>
                        <th>Oportunidades disponibles para ofertar</th>
                    </thead>
                    <tbody>
                        <tr>
                            <td class="align-middle">Mensual</td>
                            <td class="align-middle">Especialización 1</td>
                            <td class="align-middle">
                                Especialización 1<br />
                                Especialización 2<br />
                                Especialización 3
                            </td>
                            <td class="align-middle">Coincidencia con tu Especialización 1</td>
                        </tr>
                        <tr>
                            <td class="align-middle">Semestral</td>
                            <td class="align-middle">
                                Especialización 1<br />
                                Especialización 2
                            </td>
                            <td class="align-middle">
                                Especialización 1<br />
                                Especialización 2<br />
                                Especialización 3
                            </td>
                            <td class="align-middle">Coincidencia con tu Especialización 1 o 2</td>
                        </tr>
                        <tr>
                            <td class="align-middle">Anual</td>
                            <td class="align-middle">
                                Especialización 1<br />
                                Especialización 2<br />
                                Especialización 3
                            </td>
                            <td class="align-middle">
                                Especialización 1<br />
                                Especialización 2<br />
                                Especialización 3
                            </td>
                            <td class="align-middle">Coincidencia con tu Especialización 1, 2 o 3</td>
                        </tr>
                    </tbody>
                </table>

                <p>En este ejemplo, si tienes una membresía mensual, solo podrás enviar propuestas a oportunidades donde
                    coincida la primera especialización registrada por el cliente con tu primera especialización. Con
                    una
                    membresía semestral, podrás enviar propuestas a oportunidades donde coincidan la primera o segunda
                    especialización registrada por el cliente con tu primera o segunda especialización. Y si tienes una
                    membresía anual, podrás enviar propuestas a oportunidades que coincidan con cualquiera de tus tres
                    especializaciones.</p>

            </div>
        </div>

        <div class="container mb-5">
            <div class="row mb-4">
                <h1 class="text-grey text-center"><span class="bg-blue px-3">¿Qué nos preguntan</span> las
                    Empresas?</h1>
            </div>

            <div class="row">
                <p><strong>¿Cuál es el costo de registro en la plataforma?</strong></p>

                <p>Nos complace informarte que el registro en nuestra plataforma es totalmente gratuito. Queremos
                    brindarte
                    la
                    oportunidad de unirte a nuestra comunidad sin ningún costo.</p>

                <p>No hay barreras económicas para comenzar a explorar las diversas oportunidades y servicios que
                    ofrecemos.
                    Así que, ¡no dudes en registrarte hoy mismo y descubrir todo lo que nuestra plataforma tiene para
                    ofrecerte
                    sin ningún costo inicial!</p>


                <p><strong>¿Hay algún límite en la cantidad de proyectos que puedo publicar?</strong></p>

                <p>En nuestra plataforma, no hay restricciones en la cantidad de proyectos que puedes publicar. Te
                    brindamos
                    la
                    libertad de compartir todos los proyectos que desees, sin límites.</p>

                <p>Pero eso no es todo. Como parte de nuestros servicios, nos comprometemos a mantenerte informado de
                    manera
                    proactiva cuando surjan propuestas relevantes para tus proyectos. Nuestro objetivo es garantizarte
                    una
                    experiencia completa y satisfactoria, brindándote todas las oportunidades y apoyo necesarios para
                    que
                    tus
                    proyectos se materialicen con éxito.</p>

                <p>¡No esperes más y comienza a publicar tus proyectos en nuestra plataforma hoy mismo!</p>

                <p><strong>¿Cobran por los servicios que ofrecen?</strong></p>

                <p>Operamos con un modelo de negocio basado en el cobro de un pequeño porcentaje fijo del 9% únicamente sobre
                    los
                    proyectos que son adjudicados con éxito. Esto significa que no tendrás que preocuparte por gastos
                    adicionales o tarifas ocultas al utilizar nuestros servicios.</p>

                <p>Nuestro objetivo es brindarte transparencia y una relación justa en términos de costos. Así que, ¡no
                    dudes
                    en aprovechar nuestros servicios sin preocupaciones financieras y comienza a alcanzar el éxito en
                    tus
                    proyectos con nosotros!</p>

                <p><strong>¿Cómo puedo actualizar y mejorar mi perfil en la plataforma?</strong></p>

                <p>Nos preocupamos por ofrecerte un perfil completo y actualizado. Si necesitas realizar alguna
                    actualización o
                    corrección en tu perfil, no dudes en contactarnos. Nuestro equipo estará encantado de ayudarte y
                    brindarte
                    asistencia personalizada.</p>

                <p>¡Queremos asegurarnos de que aproveches al máximo todas las oportunidades que nuestra plataforma
                    puede
                    ofrecerte!</p>
            </div>
        </div>
    </main>
        
    </div>
  </template>
    
    <script>
    import { mapState } from 'vuex'
    import Header from '@/components/Header'
    export default {
      computed:{
        ...mapState(['urlWeb'])
    },
      name: 'Faq',
      components:{
        Header
    },
      data () {
        return {
        }
      }
    }
    </script>


// WEBPACK FOOTER //
// src/views/Home/Faq.vue